// extracted by mini-css-extract-plugin
export default {"jobDetailsTopNavWrapper":"styles_jobDetailsTopNavWrapper__0PFn7","jobDetailsTopNav":"styles_jobDetailsTopNav__oQ-1K","active":"styles_active__KX1Km"};